import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface TypeBackground {
    header: string;
  }

  interface Palette {
    custom: {
      secondaryBlue: string;
      tertiary: string;
      textBlue: string;
      sidebarIconBg: string;
      sidebarActiveBg: string;
      variableBg: string;
      graph: string;
      graph2: string;
      graph3: string;
      graph4: string;
      hoverBackground: string;
      selectedBackground: string;
    };
    lightGray: {
      main: string;
      text: string;
    };
  }
  interface PaletteOptions {
    custom: {
      secondaryBlue: string;
      tertiary: string;
      textBlue: string;
      sidebarIconBg: string;
      sidebarActiveBg: string;
      variableBg: string;
      graph: string;
      graph2: string;
      graph3: string;
      graph4: string;
      hoverBackground: string;
      selectedBackground: string;
    };
    lightGray: {
      main: string;
      text: string;
    };
    restaurant: {
      orderButton: string;
      reservationButton: string;
      faqButton: string;
      orderBackground: string;
      reservationBackground: string;
      faqBackground: string;
      orderBorder: string;
      reservationBorder: string;
      faqBorder: string;
    };
    background?: {
      default?: string;
      paper?: string;
      header?: string;
    };
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#5A4CE6',
    },
    secondary: {
      main: '#F8F9FC',
    },
    background: {
      default: '#FFFFFF',
      paper: '#FFFFFF',
      header: '#FFFFFF',
    },
    restaurant: {
      orderButton: '#2E7D32',
      reservationButton: '#1E88E5',
      faqButton: '#D35400',
      orderBackground: '#E6F4EA',
      reservationBackground: '#E3F2FD',
      faqBackground: '#FFE8D6',
      orderBorder: '#86B69D',
      reservationBorder: '#90CAF9',
      faqBorder: '#E0A96D',
    },
    custom: {
      secondaryBlue: '#6E61F0',
      tertiary: '#4038A7',
      textBlue: '#2B2D3F',
      sidebarIconBg: '#F4F7FF',
      sidebarActiveBg: '#E7F0FF',
      variableBg: '#FFF4CC',
      graph: '#6C5DD3',
      graph2: '#A393E8',
      graph3: '#6555C3',
      graph4: '#423399',
      hoverBackground: '#F5F5F5',
      selectedBackground: '#E7F0FF',
    },
    lightGray: {
      main: '#DCE0E7',
      text: '#6B6F80',
    },
    text: {
      primary: '#1A1A1A',
      secondary: '#6B6F80',
    },
    error: {
      main: '#E74C3C',
    },
  },
  typography: {
    fontFamily: `'DM Sans', 'Roboto'`,
  },
});

export default theme;
